import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { RadioInput } from "./RadioInput";
import styles from "./RadioGroup.scss";

const RadioGroup = ({
	className,
	groupLabelClassName,
	radioWrapperClassName,
	labelClassName,
	inputClassName,
	displayStacked,
	options,
	label,
	hideLabel,
	name,
	selectedOption,
	error,
	onChange
}) => (
	<div
		role="group"
		aria-labelledby={`${name}-group-label`}
		className={cx(className, displayStacked ? styles.stacked : styles.inline)}>
		<div
			id={`${name}-group-label`}
			className={cx(
				groupLabelClassName,
				hideLabel ? styles.hideLabel : styles.label
			)}>
			{label}
		</div>
		{options.map(option => (
			<RadioInput
				key={option.id}
				wrapperClassName={cx(styles.radioWrapper, radioWrapperClassName)}
				labelClassName={labelClassName}
				inputClassName={inputClassName}
				label={option.label}
				id={option.id}
				name={name}
				value={option.value}
				selected={selectedOption === option.value}
				error={error}
				onChange={onChange}
			/>
		))}
	</div>
);

RadioGroup.propTypes = {
	className: PropTypes.string,
	groupLabelClassName: PropTypes.string,
	radioWrapperClassName: PropTypes.string,
	labelClassName: PropTypes.string,
	inputClassName: PropTypes.string,
	displayStacked: PropTypes.bool,
	label: PropTypes.string.isRequired,
	hideLabel: PropTypes.bool,
	name: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			id: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	selectedOption: PropTypes.string,
	error: PropTypes.bool,
	onChange: PropTypes.func
};

RadioGroup.defaultProps = {
	className: undefined,
	groupLabelClassName: undefined,
	radioWrapperClassName: undefined,
	labelClassName: undefined,
	inputClassName: undefined,
	displayStacked: false,
	hideLabel: false,
	selectedOption: undefined,
	error: false,
	onChange: () => {}
};

export default RadioGroup;
export { RadioGroup };
